import "./App.css";
import Home from "./components/home.js";

function App() {
  return (
    <div className="App">
      <Home />
    </div>
  );
}

export default App;
